import { getLunarDate } from '../calender'

export const thienCan = [
  {
    id: 0,
    chuCaiDau: null,
    tenCan: null,
    nguHanh: null,
    nguHanhID: null,
    vitriDiaBan: null,
    amDuong: null
  },
  {
    id: 1,
    chuCaiDau: 'G',
    tenCan: 'Giáp',
    nguHanh: 'M',
    nguHanhID: 2,
    vitriDiaBan: 3,
    amDuong: 1,
    tenHanh: 'Mộc',
    css: 'color_moc'
  },
  {
    id: 2,
    chuCaiDau: 'A',
    tenCan: 'Ất',
    nguHanh: 'M',
    nguHanhID: 2,
    vitriDiaBan: 4,
    amDuong: -1,
    tenHanh: 'Mộc',
    css: 'color_moc'
  },
  {
    id: 3,
    chuCaiDau: 'B',
    tenCan: 'Bính',
    nguHanh: 'H',
    nguHanhID: 4,
    vitriDiaBan: 6,
    amDuong: 1,
    tenHanh: 'Hỏa',
    css: 'color_hoa'
  },
  {
    id: 4,
    chuCaiDau: 'Đ',
    tenCan: 'Đinh',
    nguHanh: 'H',
    nguHanhID: 4,
    vitriDiaBan: 7,
    amDuong: -1,
    tenHanh: 'Hỏa',
    css: 'color_hoa'
  },
  {
    id: 5,
    chuCaiDau: 'M',
    tenCan: 'Mậu',
    nguHanh: 'O',
    nguHanhID: 5,
    vitriDiaBan: 6,
    amDuong: 1,
    tenHanh: 'Thổ',
    css: 'color_tho'
  },
  {
    id: 6,
    chuCaiDau: 'K',
    tenCan: 'Kỷ',
    nguHanh: 'O',
    nguHanhID: 5,
    vitriDiaBan: 7,
    amDuong: -1,
    tenHanh: 'Thổ',
    css: 'color_tho'
  },
  {
    id: 7,
    chuCaiDau: 'C',
    tenCan: 'Canh',
    nguHanh: 'K',
    nguHanhID: 1,
    vitriDiaBan: 9,
    amDuong: 1,
    tenHanh: 'Kim',
    css: 'color_kim'
  },
  {
    id: 8,
    chuCaiDau: 'T',
    tenCan: 'Tân',
    nguHanh: 'K',
    nguHanhID: 1,
    vitriDiaBan: 10,
    amDuong: -1,
    tenHanh: 'Kim',
    css: 'color_kim'
  },
  {
    id: 9,
    chuCaiDau: 'N',
    tenCan: 'Nhâm',
    nguHanh: 'T',
    nguHanhID: 3,
    vitriDiaBan: 12,
    amDuong: 1,
    tenHanh: 'Thủy',
    css: 'color_thuy'
  },
  {
    id: 10,
    chuCaiDau: 'Q',
    tenCan: 'Quý',
    nguHanh: 'T',
    nguHanhID: 3,
    vitriDiaBan: 1,
    amDuong: -1,
    tenHanh: 'Thủy',
    css: 'color_thuy'
  }
]

export const diaChi = [
  {
    id: 0,
    tenChi: 'Hem có',
    tenHanh: ':D',
    amDuong: 0
  },
  {
    id: 1,
    tenChi: 'Tý',
    tenHanh: 'T',
    menhChu: 'Tham Lang',
    thanChu: 'Hỏa Tinh',
    amDuong: 1,
    tenHanh2: 'Thủy',
    css: 'color_thuy'
  },
  {
    id: 2,
    tenChi: 'Sửu',
    tenHanh: 'O',
    menhChu: 'Cự Môn',
    thanChu: 'Thiên Tướng',
    amDuong: -1,
    tenHanh2: 'Thổ',
    css: 'color_tho'
  },
  {
    id: 3,
    tenChi: 'Dần',
    tenHanh: 'M',
    menhChu: 'Lộc Tồn',
    thanChu: 'Thiên Lương',
    amDuong: 1,
    tenHanh2: 'Mộc',
    css: 'color_moc'
  },
  {
    id: 4,
    tenChi: 'Mão',
    tenHanh: 'M',
    menhChu: 'Văn Khúc',
    thanChu: 'Thiên Đồng',
    amDuong: -1,
    tenHanh2: 'Mộc',
    css: 'color_moc'
  },
  {
    id: 5,
    tenChi: 'Thìn',
    tenHanh: 'O',
    menhChu: 'Liêm Trinh',
    thanChu: 'Văn Xương',
    amDuong: 1,
    tenHanh2: 'Thổ',
    css: 'color_tho'
  },
  {
    id: 6,
    tenChi: 'Tỵ',
    tenHanh: 'H',
    menhChu: 'Vũ Khúc',
    thanChu: 'Thiên Cơ',
    amDuong: -1,
    tenHanh2: 'Hỏa',
    css: 'color_hoa'
  },
  {
    id: 7,
    tenChi: 'Ngọ',
    tenHanh: 'H',
    menhChu: 'Phá Quân',
    thanChu: 'Hỏa Tinh',
    amDuong: 1,
    tenHanh2: 'Hỏa',
    css: 'color_hoa'
  },
  {
    id: 8,
    tenChi: 'Mùi',
    tenHanh: 'O',
    menhChu: 'Vũ Khúc',
    thanChu: 'Thiên Tướng',
    amDuong: -1,
    tenHanh2: 'Thổ',
    css: 'color_tho'
  },
  {
    id: 9,
    tenChi: 'Thân',
    tenHanh: 'K',
    menhChu: 'Liêm Trinh',
    thanChu: 'Thiên Lương',
    amDuong: 1,
    tenHanh2: 'Kim',
    css: 'color_kim'
  },
  {
    id: 10,
    tenChi: 'Dậu',
    tenHanh: 'K',
    menhChu: 'Văn Khúc',
    thanChu: 'Thiên Đồng',
    amDuong: -1,
    tenHanh2: 'Kim',
    css: 'color_kim'
  },
  {
    id: 11,
    tenChi: 'Tuất',
    tenHanh: 'O',
    menhChu: 'Lộc Tồn',
    thanChu: 'Văn Xương',
    amDuong: 1,
    tenHanh2: 'Thổ',
    css: 'color_tho'
  },
  {
    id: 12,
    tenChi: 'Hợi',
    tenHanh: 'T',
    menhChu: 'Cự Môn',
    thanChu: 'Thiên Cơ',
    amDuong: -1,
    tenHanh2: 'Thủy',
    css: 'color_thuy'
  }
]

export const ngayThangNam = (dd, mm, yyyy) => {
  return getLunarDate(dd, mm, yyyy)
}

export const canChiNgay = (dd, mm, yyyy) => {
  const lunar = ngayThangNam(dd, mm, yyyy)
  const canNgay = (lunar.jd + 9) % 10 + 1
  const chiNgay = (lunar.jd + 1) % 12 + 1
  return [canNgay, chiNgay]
}

export const ngayThangNamCanChi = (dd, mm, yyyy) => {
  const lunar = ngayThangNam(dd, mm, yyyy)
  const canThang = (lunar.year * 12 + lunar.month + 3) % 10 + 1
  const chiThang = (lunar.month + 1) % 12 + 1

  // Can chi của năm
  const canNamSinh = (lunar.year + 6) % 10 + 1
  const chiNam = (lunar.year + 8) % 12 + 1
  return [canThang, chiThang, canNamSinh, chiNam]
}

export const nguHanh = (tenHanh) => {
  if (['Kim', 'K'].includes(tenHanh)) {
    return { id: 1, tenHanh: 'Kim', cuc: 4, tenCuc: 'Kim Tứ Cục', css: 'color_kim' }
  } else if (['Moc', 'M'].includes(tenHanh)) {
    return { id: 2, tenHanh: 'Mộc', cuc: 3, tenCuc: 'Mộc Tam Cục', css: 'color_moc' }
  } else if (['Thuy', 'T'].includes(tenHanh)) {
    return { id: 3, tenHanh: 'Thủy', cuc: 2, tenCuc: 'Thủy Nhị Cục', css: 'color_thuy' }
  } else if (['Hoa', 'H'].includes(tenHanh)) {
    return { id: 4, tenHanh: 'Hỏa', cuc: 6, tenCuc: 'Hỏa Lục Cục', css: 'color_hoa' }
  } else if (['Tho', 'O'].includes(tenHanh)) {
    return { id: 5, tenHanh: 'Thổ', cuc: 5, tenCuc: 'Thổ Ngũ Cục', css: 'color_tho' }
  } else {
    return new Error('Tên Hành phải thuộc Kim (K), Mộc (M), Thủy (T), Hỏa (H) hoặc Thổ (O)')
  }
}

export const sinhKhac = (hanh1, hanh2) => {
  const matranSinhKhac = [
    [null, null, null, null, null, null],
    [null, 0, -1, 1, -2, 2],
    [null, -2, 0, 2, 1, -1],
    [null, 2, 1, 0, -1, -2],
    [null, -1, 2, -2, 0, 1],
    [null, 1, -2, -1, 2, 0]
  ]
  return matranSinhKhac[hanh1][hanh2]
}

/**
 * @param diaChi: Số thứ tự của địa chi (Tý=1, Sửu=2,...)
 * @param thienCan: Số thứ tự của thiên can (Giáp=1, Ất=2,...)
 * @param xuatBanMenh
 * @returns Trả về chữ viết tắt Hành của năm (K, T, H, O, M)
 */
export const nguHanhNapAm = (diaChi, thienCan, xuatBanMenh = false) => {
  const banMenh = {
    K1: 'HẢI TRUNG KIM',
    T1: 'GIẢN HẠ THỦY',
    H1: 'TÍCH LỊCH HỎA',
    O1: 'BÍCH THƯỢNG THỔ',
    M1: 'TANG ÐỐ MỘC',
    T2: 'ÐẠI KHÊ THỦY',
    H2: 'LƯ TRUNG HỎA',
    O2: 'THÀNH ÐẦU THỔ',
    M2: 'TÙNG BÁCH MỘC',
    K2: 'KIM BẠCH KIM',
    H3: 'PHÚC ÐĂNG HỎA',
    O3: 'SA TRUNG THỔ',
    M3: 'ÐẠI LÂM MỘC',
    K3: 'BẠCH LẠP KIM',
    T3: 'TRƯỜNG LƯU THỦY',
    K4: 'SA TRUNG KIM',
    T4: 'THIÊN HÀ THỦY',
    H4: 'THIÊN THƯỢNG HỎA',
    O4: 'LỘ BÀNG THỔ',
    M4: 'DƯƠNG LIỄU MỘC',
    T5: 'TUYỀN TRUNG THỦY',
    H5: 'SƠN HẠ HỎA',
    O5: 'ÐẠI TRẠCH THỔ',
    M5: 'THẠCH LỰU MỘC',
    K5: 'KIẾM PHONG KIM',
    H6: 'SƠN ÐẦU HỎA',
    O6: 'ỐC THƯỢNG THỔ',
    M6: 'BÌNH ÐỊA MỘC',
    K6: 'THOA XUYẾN KIM',
    T6: 'ÐẠI HẢI THỦY'
  }
  const matranNapAm = [
    [0, 'Giáp', 'Ất', 'Bính', 'Đinh', 'Mậu', 'Kỷ', 'Canh', 'Tân', 'Nhâm', 'Qúy'],
    [1, 'K1', false, 'T1', false, 'H1', false, 'O1', false, 'M1', false],
    [2, false, 'K1', false, 'T1', false, 'H1', false, 'O1', false, 'M1'],
    [3, 'T2', false, 'H2', false, 'O2', false, 'M2', false, 'K2', false],
    [4, false, 'T2', false, 'H2', false, 'O2', false, 'M2', false, 'K2'],
    [5, 'H3', false, 'O3', false, 'M3', false, 'K3', false, 'T3', false],
    [6, false, 'H3', false, 'O3', false, 'M3', false, 'K3', false, 'T3'],
    [7, 'K4', false, 'T4', false, 'H4', false, 'O4', false, 'M4', false],
    [8, false, 'K4', false, 'T4', false, 'H4', false, 'O4', false, 'M4'],
    [9, 'T5', false, 'H5', false, 'O5', false, 'M5', false, 'K5', false],
    [10, false, 'T5', false, 'H5', false, 'O5', false, 'M5', false, 'K5'],
    [11, 'H6', false, 'O6', false, 'M6', false, 'K6', false, 'T6', false],
    [12, false, 'H6', false, 'O6', false, 'M6', false, 'K6', false, 'T6']
  ]

  const nh = matranNapAm[diaChi][thienCan]
  if (['K', 'M', 'T', 'H', 'O'].includes(nh[0])) {
    return xuatBanMenh ? banMenh[nh] : nh[0]
  }
}

export function dichCung (cungBanDau, ...args) {
  var cungSauKhiDich = parseInt(cungBanDau)
  for (var index in args) {
    const soCungDich = args[index]
    cungSauKhiDich += parseInt(soCungDich)
  }
  const mod = cungSauKhiDich % 12
  if (mod % 12 === 0) {
    return 12
  } else if (mod < 0) {
    return 12 + mod
  } else {
    return mod
  }
  // return mod % 12 === 0 ? 12 : mod
}

export function dichCungCan (cungBanDau, ...args) {
  var cungSauKhiDich = parseInt(cungBanDau)
  for (var index in args) {
    const soCungDich = args[index]
    cungSauKhiDich += parseInt(soCungDich)
  }
  const mod = cungSauKhiDich % 10
  if (mod % 10 === 0) {
    return 10
  } else if (mod < 0) {
    return 10 + mod
  } else {
    return mod
  }
  // return mod % 12 === 0 ? 12 : mod
}

export const khoangCachCung = (cung1, cung2, chieu = 1) => {
  if (chieu === 1) { // Con trai, chiều dương
    return (cung1 - cung2 + 12) % 12
  } else {
    return (cung2 - cung1 + 12) % 12
  }
}
export const timCuc = (viTriCungMenhTrenDiaBan, canNamSinh) => {
  // khoi vi tri dau theo ngu ho don
  let khoiCan
  if ([1, 6].includes(canNamSinh)) {
    khoiCan = 3
  } else if ([2, 7].includes(canNamSinh)) {
    khoiCan = 5
  } else if ([3, 8].includes(canNamSinh)) {
    khoiCan = 7
  } else if ([4, 9].includes(canNamSinh)) {
    khoiCan = 9
  } else if ([5, 10].includes(canNamSinh)) {
    khoiCan = 1
  }

  var k1 = (viTriCungMenhTrenDiaBan - 2 + 12) % 12
  k1 = k1 === 0 ? 12 : k1
  var khoangCach = (k1 + khoiCan - 1) % 10
  khoangCach = khoangCach === 0 ? 10 : khoangCach
  // const canThangGieng = (canNamSinh * 2 + 1) % 10
  // const khoangCachVoiCungDan = Math.abs(viTriCungMenhTrenDiaBan - 3)
  // let canThangMenh = (khoangCachVoiCungDan % 12 + canThangGieng) % 10
  // if (canThangMenh === 0) {
  //   canThangMenh = 10
  // }
  return nguHanhNapAm(viTriCungMenhTrenDiaBan, khoangCach)
}

// Tìm vị trí của sao Tử vi
export const timTuVi = (cuc, ngaySinhAmLich) => {
  let cungDan = 3 // Vị trí cung Dần ban đầu là 3
  const cucBanDau = cuc
  if (![2, 3, 4, 5, 6].includes(cuc)) { // Tránh trường hợp infinite loop
    return new Error('Số cục phải là 2, 3, 4, 5, 6')
  }

  while (cuc < ngaySinhAmLich) {
    cuc += cucBanDau
    cungDan += 1 // Dịch vị trí cung Dần
  }

  let saiLech = cuc - ngaySinhAmLich
  if (saiLech % 2 === 1) {
    saiLech = -saiLech // Nếu sai lệch là chẵn thì tiến, lẻ thì lùi
  }
  return dichCung(cungDan, saiLech)
}

/**
 * Tìm vị trí của Tràng sinh
 * Theo thứ tự cục số
 * vị trí Tràng sinh sẽ là Dần, Tỵ, Thân hoặc Hợi
 * @param cucSo: số cục (2, 3, 4, 5, 6)
 * @returns {number}: Vị trí sao Tràng sinh
 */
export const timTrangSinh = (cucSo) => {
  switch (cucSo) {
    case 6: // Hỏa lục cục
      return 3 // Tràng sinh ở Dần
    case 4: // Kim tứ cục
      return 6 // Tràng sinh ở Tỵ
    case 2: // Thủy nhị cục
    case 5: // Thổ ngũ cục
      return 9 // Tràng sinh ở Thân
    case 3: // Mộc tam cục
      return 12 // Tràng sinh ở Hợi
    default:
      return 'Không tìm được cung an sao Trường sinh'
  }
}

export const timHoaLinh = (chiNamSinh, gioSinh, gioiTinh, amDuongNamSinh) => {
  let khoiCungHoaTinh, khoiCungLinhTinh
  if ([3, 7, 11].includes(chiNamSinh)) {
    khoiCungHoaTinh = 2
    khoiCungLinhTinh = 4
  } else if ([1, 5, 9].includes(chiNamSinh)) {
    khoiCungHoaTinh = 3
    khoiCungLinhTinh = 11
  } else if ([6, 10, 2].includes(chiNamSinh)) {
    khoiCungHoaTinh = 4
    khoiCungLinhTinh = 11
  } else if ([12, 4, 8].includes(chiNamSinh)) {
    khoiCungHoaTinh = 10
    khoiCungLinhTinh = 11
  } else {
    return new Error('Không thể khởi cung tìm Hỏa-Linh')
  }

  let viTriHoaTinh, viTriLinhTinh
  if (gioiTinh * amDuongNamSinh === -1) {
    viTriHoaTinh = dichCung(khoiCungHoaTinh + 1, (-1) * gioSinh)
    viTriLinhTinh = dichCung(khoiCungLinhTinh - 1, gioSinh)
  } else if (gioiTinh * amDuongNamSinh === 1) {
    viTriHoaTinh = dichCung(khoiCungHoaTinh - 1, gioSinh)
    viTriLinhTinh = dichCung(khoiCungLinhTinh + 1, (-1) * gioSinh)
  }
  return [viTriHoaTinh, viTriLinhTinh]
}

export const timThienKhoi = (canNam) => {
  const khoiViet = [null, 2, 1, 12, 12, 2, 1, 2, 7, 4, 4]
  return khoiViet[canNam]
}

export const timThienQuanThienPhuc = (canNam) => {
  // Giáp dương Nhâm khuyển Ất long nghi
  // Mậu thổ Canh chư Quý mã thượng
  // Kỳ nhân quý hiển khả tiên tri
  const thienQuan = [null, 8, 5, 6, 3, 4, 10, 12, 10, 11, 7]
  // Giáp ái kim kê Ất ái hầu
  // Đinh chư Bính thử Kỷ hổ đầu
  // Tân quý phùng xà phúc lộc nhiêu
  const thienPhuc = [null, 10, 9, 1, 12, 4, 3, 7, 6, 7, 6]

  return [thienQuan[canNam], thienPhuc[canNam]]
}

export const timCoThan = (chiNam) => {
  if ([12, 1, 2].includes(chiNam)) {
    return 3
  } else if ([3, 4, 5].includes(chiNam)) {
    return 6
  } else if ([6, 7, 8].includes(chiNam)) {
    return 9
  } else {
    return 12
  }
}

export const timThienMa = (chiNam) => {
  const demNghich = chiNam % 4
  switch (demNghich) {
    case 1:
      return 3
    case 2:
      return 12
    case 3:
      return 9
    case 0:
      return 6
    default:
      return 'Không tìm được Thiên mã'
  }
}

export const timPhaToai = (chiNam) => {
  const demNghich = chiNam % 3
  switch (demNghich) {
    case 1:
      return 6
    case 2:
      return 2
    case 0:
      return 10
    default:
      return 'Không tìm được Phá toái'
  }
}

export const timTriet = (canNam) => {
  if ([1, 6].includes(canNam)) { // Giáp Kỷ, Thân Dậu cung
    return [9, 10]
  } else if ([2, 7].includes(canNam)) { // Ất Canh, Ngọ Mùi cung
    return [7, 8]
  } else if ([3, 8].includes(canNam)) { // Bính Tân, Thìn Tị cung
    return [5, 6]
  } else if ([4, 9].includes(canNam)) { // Đinh Nhâm, Dần Mão cung
    return [3, 4]
  } else if ([5, 10].includes(canNam)) { // Mậu Quý, Tý Sửu cung
    return [1, 2]
  }
}

export const timLuuTru = (canNam) => {
  const maTranLuuHa = [null, 10, 11, 8, 5, 6, 7, 9, 4, 12, 3]
  const maTranThienTru = [null, 6, 7, 1, 6, 7, 9, 3, 7, 10, 11]
  return [maTranLuuHa[canNam], maTranThienTru[canNam]]
}
